import React, { useEffect, useState, useCallback } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import MainLayout from "@layout/MainLayout";
import { hs } from "@hlibs/index";
import { useAccount } from "@redux/account";
import { useMenuDispatch } from "@assets/contexts/MenuContext";
import PermissionPage from "./PermissionPage";

const ViewDashboard = () => {
  const value = useMenuDispatch();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const account = useAccount();

  const handleLogout = useCallback(() => {
    account.logout((data, response) => {
      value({ type: "reset" });
      navigate("/login", { replace: true });
    });
  }, [account, navigate, value]);

  const handleHomeGo = useCallback(() => {
    navigate("/");
  }, [navigate]);

  useEffect(() => {
    value({ type: "loadingStart" });

    if (account.tokenCheckResponse === undefined) {
      account.tokenCheck((data, response) => {
        if (response.status === 200 && data.error === undefined) {
          value({ type: "userset", payload: data.permission });
          value({ type: "loadingEnd" });
          setLoading(false);
        } else {
          value({ type: "loadingEnd" });
          setLoading(false);
          navigate("/login", { replace: true });
        }
      });
    } else {
      setLoading(false);
      value({ type: "loadingEnd" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!loading && (
        <PermissionPage>
          <MainLayout
            account={account}
            onLogout={handleLogout}
            style={[hs.verticalLayout(), hs.verticalAlign.center()]}
            onHome={handleHomeGo}
          >
            <Container maxWidth="lg" disableGutters={true}>
              <Outlet />
            </Container>
          </MainLayout>
        </PermissionPage>
      )}
    </>
  );
};

export default ViewDashboard;
